<template>
  <div :id="`${videoId}_vidControlsContainer`" class='background' >
    <div :id="`${videoId}_vidGradientTop`" class="vidGradientTop"></div>
    <div :id="`${videoId}_vidGradient`" class="vidGradient"></div>
    <div :id="`${videoId}_vidControls`" class="vidControls">
      <div :id="`${videoId}_rewind`" class="vctrl_rewind" v-show="false" @click="vid.currentTime = 0"></div>
      <div :id="`${videoId}_playpause`" class="vctrl_playpause paused" @click="togglePause"></div>
      <div :id="`${videoId}_progressBar`" class="vctrl_progressBar" @click="onProgBarClick">
        <div :id="`${videoId}_progress`" class="vctrl_progress" style="width: 12%;"></div>
        <div :id="`${videoId}_playhead`" class="vctrl_playhead" style="left: 12%;" @touchstart="touchHandler" @mousedown="onScrubberDown">
        </div>
      </div>
      <span :id="`${videoId}_time`" class="vctrl_time"></span>
    </div>
  </div>
</template>

<script>
  import { TweenMax } from 'gsap';


  export default {
    name: 'video-controls',
    props: ['videoId'],
    created() {
      this.goingToHideControl = null;
    },
    data() {
      return {
        vidGradientTop: undefined,
        vidGradient: undefined,

        vid: undefined,
        controls: undefined,
        rewind: undefined,
        playpause: undefined,
        playhead: undefined,
        progress: undefined,
        progressBar: undefined,
        timeInfo: undefined,
        showingControls: false,
        controlsOnscreen: false,
        dragging: false,
        videoPastOneSecond: false,
      };
    },
    mounted() {
      this.vid = document.getElementById(this.videoId);
      this.container = document.getElementById(this.getContainerId());
      // debugger;
      this.controls = document.getElementById(this.getControlId());
      this.rewind = document.getElementById(this.getRewindId());
      this.playpause = document.getElementById(this.getPlaypauseId());
      this.progressBar = document.getElementById(this.getProgressBarId());
      this.progress = document.getElementById(this.getProgressId());
      this.playhead = document.getElementById(this.getPlayheadId());
      this.timeInfo = document.getElementById(this.getTimeInfoId());
      this.vidGradientTop = document.getElementById(this.getVidGradientTopId());
      this.vidGradient = document.getElementById(this.getVidGradientId());
      this.timeInfo.innerText = '';

      // this.rewind.addEventListener("click", () => {
      //   this.vid.currentTime = 0;
      // });
      // this.playpause.addEventListener("click", () => {
      //   this.togglePause();
      // });

      // this.playhead.addEventListener("mousedown", this.onScrubberDown);
      // this.playhead.addEventListener("touchstart", this.touchHandler);
      //
      // this.progressBar.addEventListener("click", this.onProgBarClick);
      this.resetControls();
      this.addVidEvents();
    },


    methods: {
      getContainerId() { return `${this.videoId}_vidControlsContainer`; },
      getControlId() { return `${this.videoId}_vidControls`; },
      getRewindId() { return `${this.videoId}_rewind`; },
      getPlaypauseId() { return `${this.videoId}_playpause`; },
      getPlayheadId() { return `${this.videoId}_playhead`; },
      getProgressBarId() { return `${this.videoId}_progressBar`; },
      getProgressId() { return `${this.videoId}_progress`; },
      getTimeInfoId() { return `${this.videoId}_time`; },
      getVidGradientTopId() { return `${this.videoId}_vidGradientTop`; },
      getVidGradientId() { return `${this.videoId}_vidGradient`; },


      hideControlIn3Sec() {
        // cancel previous hide function
        if (this.goingToHideControl) {
          this.cancelHideControlIn3Sec();
        }
        const that = this;
        this.goingToHideControl = setTimeout(() => {
          that.hideControls();
        }, 3000);
      },
      cancelHideControlIn3Sec() {
        clearTimeout(this.goingToHideControl);
      },
      onParentClick(e) {
        this.showControls();
      },

      //Hiding animations here
      hideControls() {
        if (this.vid.paused && !this.dragging) {
          // TweenMax.delayedCall(2, this.hideControls);
          return;
        }
        this.showingControls = false;
        this.controlsOnscreen = false;

        TweenMax.to(this.vidGradientTop, 0.25, {autoAlpha:0});
        TweenMax.to(this.vidGradient, 0.25, {autoAlpha:0});
        TweenMax.to(this.controls, 0.25, { autoAlpha:0 });
        this.$emit('hide-vid-controls');

        // console.log('close button is triggered.');
      },
      showControls() {
        // if (!this.videoPastOneSecond) return;

        this.showingControls = true;
        this.controlsOnscreen = true;
        TweenMax.to(this.vidGradientTop, 0.25, { autoAlpha:1 });
        TweenMax.to(this.vidGradient, 0.25, { autoAlpha:1 });
        TweenMax.to(this.controls, 0.25, { autoAlpha:1 });
        this.$emit('show-vid-controls');
        this.hideControlIn3Sec();

        // this.$nextTick(() => {
        //   TweenMax.delayedCall(3, this.hideControls);
        // });
      },
      addVidEvents() {
        const that = this;
        this.vid.addEventListener('pause', () => {
          that.playpause.classList.add('paused');
        });
        this.vid.addEventListener('playing', () => {
          that.playpause.classList.remove('paused');
        });
        this.vid.addEventListener('ended', () => {

        });

        parent.addEventListener('click', this.onParentClick);
        parent.addEventListener('mousemove', this.onParentClick);

        window.requestAnimationFrame(this.onTick);
      },
      onTick(delta) {
        // request to show cntrls after 1 sec..
        this.videoPastOneSecond = this.vid.currentTime >= 1 ? true : false;
        //
        const progAmt = Math.round(this.vid.currentTime / this.vid.duration * 100);

        this.progress.style.width = progAmt.toString() + '%';

        if (!this.dragging) {
          this.playhead.style.left = progAmt.toString() + '%';
        } else {
          this.handlePlayheadDrag();
        }

        const time = this.vid.currentTime;
        this.timeInfo.innerText = `${this.seconds2time(time)}`;

        window.requestAnimationFrame(this.onTick);
      },
      seconds2time (timeInSecond) {
        var seconds = Math.floor(timeInSecond);
        var hours   = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = seconds - (hours * 3600) - (minutes * 60);

        // if (hours   < 10) {hours   = '0'+hours;}
        // if (minutes < 10) {minutes = '0'+minutes;}
        if (seconds < 10) {seconds = '0'+seconds;}
        return `${minutes}:${seconds}`;
      },
      handlePlayheadDrag() {
        this.seekToPlayhead();
      },
      onProgBarClick(e) {
        var progress = this.getUserProgressFromEvent(e);

        this.vid.currentTime = this.vid.duration * progress;
      },
      onScrubberDown(e) {
        if (this.dragging) {
          return;
        }

        e.preventDefault();

        this.dragging = true;
        window.addEventListener('mouseup', this.onDocUp);
        window.addEventListener('mousemove', this.onScrub);

        window.addEventListener('touchend', this.touchHandler);
        window.addEventListener('touchcancel', this.touchHandler);
        window.addEventListener('touchmove', this.touchHandler);
      },
      touchHandler(event) {
        var touches = event.changedTouches;
        var first = touches[0];
        var type = '';

        switch (event.type) {
          case 'touchstart':
            type = 'mousedown';
            break;
          case 'touchmove':
            type = 'mousemove';
            break;
          case 'touchend':
            type = 'mouseup';
            break;
          default:
            return;
        }

        var simulatedEvent = document.createEvent('MouseEvent');
        simulatedEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0, null);

        first.target.dispatchEvent(simulatedEvent);
        if (event.type != 'touchend') {
          //event.preventDefault();
        }
      },
      onScrub(e) {
        const userProgress = this.getUserProgressFromEvent(e);

        this.playhead.style.left = (userProgress * 100).toString() + '%';
      },
      getUserProgressFromEvent(e) {
        const appContainer = document.getElementById('app'); //The main container of the app
        const scaleAmt = window.appDashScalingFactor; //Note for the dragging to work this scale value needs to be updated when your browser window size changes.

        // console.log(`Scaling factor is ${window.appDashScalingFactor}`);
        const inverseScale = 1 / scaleAmt;
        const appLeftOriginal = appContainer.offsetLeft;
        const appLeft = appLeftOriginal * scaleAmt;
        const userX = e.pageX - appLeft;
        //let pbarRectLeft = $(this.progressBar).offset().left;
        let pbarRectLeft = this.progressBar.getBoundingClientRect().left;

        /**
         *
         *  NOTE: this.progressBar.getBoundingClientRect().left has different values in IE and Chrome
         *  Thus we can't use this calculation for scrub bar.  So we are not using a custom vid controls
         */

        // console.log(`BoundingClientRect.left is ${pbarRectLeft}`);
        // console.log(`window.innerWidth is ${window.innerWidth}`);
        pbarRectLeft *= scaleAmt;
        const pbarLeft = pbarRectLeft - appLeft;
        const progBarWidth = this.progressBar.offsetWidth;

        let userProgress = (userX - pbarLeft) / progBarWidth * inverseScale;
        if (userProgress < 0) userProgress = 0;
        if (userProgress > 1) userProgress = 1;

        return userProgress;
      },
      onDocUp(e) {
        this.seekToPlayhead();
        this.dragging = false;
        window.removeEventListener('mouseup', this.onDocUp);
        window.removeEventListener('mousemove', this.onScrub);
        window.removeEventListener('touchend', this.touchHandler);
        window.removeEventListener('touchcancel', this.touchHandler);
        window.removeEventListener('touchmove', this.touchHandler);
      },
      seekToPlayhead() {
        // trace('Seeking to playhead');
        const pct = parseFloat(this.playhead.style.left.split('%')[0]);
        this.vid.currentTime = this.vid.duration * pct / 100;
      },
      togglePause() {
        this.vid.paused ? this.vid.play() : this.vid.pause();
      },
      resetControls() {
        this.progress.style.width = '0%';
        this.playhead.style.left = '0%';

        this.hideControls();
      },
    },
  };
</script>

<style lang="css" rel="stylesheet/css" scoped>
  #app video {
    z-index: 900;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: all;
  }

  #app video.vidPlaying {
    z-index: 920;
    width: 100%;
    height: 100%;
    pointer-events: all;
  }

  #app .vidGradient {
    position: absolute;
    bottom: 0px;
    height: 140px;
    width: 100%;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
    z-index: 929;
    content: '  ';
    pointer-events: none;
    opacity: 0;
  }

  #app .vidGradientTop {
    position: absolute;
    top: 0px;
    height: 140px;
    width: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
    z-index: 15;
    content: '  ';
    pointer-events: none;
  }

  #app .vidControls {
    z-index: 930;
    position: relative;
    margin: 0 auto;
    top: 965px;
    width: 1140px;
    pointer-events: all;
  }

  #app .vidControls div {
    display: inline-block;
    margin-right: 30px;
    height: 86px;
    pointer-events: all;
  }

  #app .vidControls .vctrl_rewind {
    background-image: url("./restart_Norm.png");
    background-repeat: no-repeat;
    width: 62px;
    height: 57px;
    top: -14px;
    position: relative;
    cursor: pointer;
  }

  #app .vidControls .vctrl_rewind:hover {
    opacity: 0.8;
    background-image: url("./restart_Roll.png");
  }

  #app .vidControls .vctrl_playpause {
    top: -14px;
    position: relative;
    width: 62px;
    height: 57px;
    margin-right: 55px;
    background-image: url("./pause_Norm.png");
    background-repeat: no-repeat;
    cursor: pointer;
  }

  #app .vidControls .vctrl_playpause:hover {
    opacity: 0.8;
    background-image: url("./pause_Roll.png");
  }

  #app .vidControls .vctrl_playpause.paused {
    background-image: url("./play_Norm.png");
  }

  #app .vidControls .vctrl_playpause.paused:hover {
    opacity: 0.8;
    background-image: url("./play_Roll.png");
  }

  #app .vidControls .vctrl_time {
    bottom: 35px;
    position: relative;
    font-size: 26px;
    left: 35px;
    margin-left: 0px;
    text-align: right;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
  }

  #app .vidControls .vctrl_progressBar {
    background-image: url("./container.png");
    background-position: 50% 50%;
    background-repeat: no-repeat;
    width: 805px;
    margin-right: 0px;
    position: relative;
  }

  #app .vidControls .vctrl_progressBar .vctrl_progress {
    background-image: url("./fill.png");
    background-position: 0px 50%;
    background-repeat: repeat-x;
    width: 0%;
    margin-right: 0px;
    height: 100%;
  }

  #app .vidControls .vctrl_progressBar .vctrl_playhead {
    background-image: url("./position.png");
    position: absolute;
    background-position: 50% 50%;
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    margin-right: 0px;
    left: 0%;
    top: 36%;
  }

</style>



// WEBPACK FOOTER //
// Video-Controls.vue?02095abf